
import router from '@/router'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup() {
    const searchText = ref('' as string)
    const inputRef = ref<HTMLInputElement>()
    const searchConcept = () => {
      if (searchText.value.trim()) {
        router.push(`/topicList/${searchText.value.trim()}`)
      } else {
        searchText.value = ''
      }
    }
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        searchConcept()
      }
    }

    const iconClick = () => {
      searchText.value = ''
      setTimeout(() => {
        inputRef.value?.focus()
      }, 200)
    }

    return {
      searchText,
      searchConcept,
      handleKeydown,
      iconClick,
      inputRef,
    }
  },
})
